export const tourneesGraffitiConstants = {
    TOURNEES_GRAFFITI_FETCH_REQUEST: 'TOURNEES_GRAFFITI_FETCH_REQUEST',
    TOURNEES_GRAFFITI_FETCH_SUCCESS: 'TOURNEES_GRAFFITI_FETCH_SUCCESS',
    TOURNEES_GRAFFITI_FETCH_FAILURE: 'TOURNEES_GRAFFITI_FETCH_FAILURE',
    TOURNEES_GRAFFITI_DELETE_REQUEST: 'TOURNEES_GRAFFITI_DELETE_REQUEST',
    TOURNEES_GRAFFITI_DELETE_SUCCESS: 'TOURNEES_GRAFFITI_DELETE_SUCCESS',
    TOURNEES_GRAFFITI_DELETE_FAILURE: 'TOURNEES_GRAFFITI_DELETE_FAILURE',
    TOURNEES_GRAFFITI_CLEAR: 'TOURNEES_GRAFFITI_CLEAR',
};
